import { apiFetch } from './apiClient.js';

export interface VariableMapping {
  id: string;
  tenantId: string;
  name: string;
  sourceField: string;
  zeField: string;
  targetField?: string;
  status: string;
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export async function listVariables(tenantId: string): Promise<VariableMapping[]> {
  const res = await apiFetch<{ items: VariableMapping[] }>(`/v1/tenants/${encodeURIComponent(tenantId)}/variables`);
  return res.items;
}
